import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { Company } from '@common/models';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all modules
   */
  getAll() {
    return this._http.get<Company[]>(`${environment.commonApiUrl}/api/companies`);
  }

  /**
   * Get the companies the logged user has access to
   */
  getUserCompanies() {
    return this._http.get<Company[]>(`${environment.commonApiUrl}/api/companies/user`);
  }

  /**
   * Get module by id
   */
  getById(id: number) {
    return this._http.get<Company>(`${environment.commonApiUrl}/api/companies/${id}`);
  }

  addCompany(company){
    return this._http.post<Company>(`${environment.commonApiUrl}/api/companies`, company).pipe(
      map((response: any) => response.company as Company),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editCompany(company){
    return this._http.put<Company>(`${environment.commonApiUrl}/api/companies/${company.id}`, company).pipe(
      map((response: any) => response.company as Company),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, status: string) {
    return this._http.put<Company>(`${environment.commonApiUrl}/api/companies/${id}/${status}`,{}).pipe(
      map((response: any) => response.company as Company),
      catchError(e => {
        return throwError(e);
      })
    );
  }
  
}
